import { ENV_IDENTIFIER, IS_LOCAL } from './constants';

const APP_ALL_CONFIG = {
  [ENV_IDENTIFIER.DEV]: {
    HOST_URL: 'https://mall-dev.3jyx.cn',
    HOST: 'mall-dev.3jyx.cn',
    STATIC_PATH: `https://public-test-shop.oss-cn-shenzhen.aliyuncs.com`,
    QIDIAN_SERVICEURL: `https://wpa1.qq.com/STPaoL40?_type=wpa&qidian=true`,
    DELIVERY_ORDER: 'https://m-dev.3jyx.cn',
  },
  [ENV_IDENTIFIER.TEST]: {
    HOST_URL: 'https://mall-st.3jyx.cn',
    HOST: 'mall-st.3jyx.cn',
    STATIC_PATH: `https://public-test-shop.oss-cn-shenzhen.aliyuncs.com`,
    QIDIAN_SERVICEURL: `https://wpa1.qq.com/STPaoL40?_type=wpa&qidian=true`,
    DELIVERY_ORDER: 'https://m-test.3jyx.cn',
  },
  [ENV_IDENTIFIER.PRE]: {
    HOST_URL: 'http://mall-pre.3jyx.cn',
    HOST: 'mall-pre.3jyx.cn',
    STATIC_PATH: `https://static-tg.3jyx.cn`,
    QIDIAN_SERVICEURL: `https://wpa1.qq.com/isVhkFg3?_type=wpa&qidian=true`,
    DELIVERY_ORDER: 'https://m.3jyx.cn',
  },
  [ENV_IDENTIFIER.PRODUCT]: {
    HOST_URL: 'https://www.3jyx.cn',
    HOST: 'www.3jyx.cn',
    STATIC_PATH: `https://static-tg.3jyx.cn`,
    QIDIAN_SERVICEURL: `https://wpa1.qq.com/isVhkFg3?_type=wpa&qidian=true`,
    DELIVERY_ORDER: 'https://m.3jyx.cn',
  },
};

//
const env = IS_LOCAL ? process.env.API_ENV : process.env.ENV;
export const APP_CONFIG: any = APP_ALL_CONFIG[env || ENV_IDENTIFIER.TEST] || {};
